import React, { useMemo } from "react";
import { v4 } from "uuid";
import classNames from "classnames";
import "./TableInfoFooter.scss";

import TableInfoCell from "components/uiComponents/TableInfoCell";

import { numberWithCommas } from "utils/helpers";

const TableInfoFooter = ({
  selectedTotals,
  rows,
  checkList,
  totals,
  unitsArr,
}) => {
    selectedTotals[0] = "";

  const cols = useMemo(() => {
    if (selectedTotals && Array.isArray(selectedTotals) && selectedTotals.length) {
      totals[0] = `Selected: ${numberWithCommas(Object.keys(checkList)?.length)} / ${numberWithCommas(rows?.length)}`
    } else {
      totals[0] = `Total: ${numberWithCommas(rows?.length)}`
    }

    return totals.map((el, index) => {
      let elUpd = el;
      let selectedElUpd = selectedTotals[index];

      if (typeof el === 'number') {
        if (el % 1 !== 0) {
          elUpd = numberWithCommas(el.toFixed(2));
        } else {
          elUpd = numberWithCommas(el);
        }
      }

      if (typeof selectedTotals[index] === 'number') {
        if (selectedTotals[index] % 1 !== 0) {
          selectedElUpd = numberWithCommas(selectedTotals[index].toFixed(2));
        } else {
          selectedElUpd = numberWithCommas(selectedElUpd);
        }
      }

      if (index === 0) {
        return (
          <TableInfoCell key={v4()}>
            <div className="table-info-footer__cell table-info-footer__cell--first">
              {(!!selectedElUpd || selectedElUpd === 0) && selectedElUpd}

              {elUpd}
            </div>
          </TableInfoCell>
        )
      } else {
        return (
          <TableInfoCell key={v4()}>
            <div className="table-info-footer__cell">
              {(!!selectedElUpd || selectedElUpd === 0) && (!!elUpd || elUpd === 0) &&
                <>
                  <span>{selectedElUpd}&nbsp;</span>

                  <span className="table-info-footer__cell_units">
                    {unitsArr?.[index]?.unit}
                  </span>

                  <span className="table-info-footer__cell_sup">{unitsArr?.[index]?.subUnit}</span>

                  <span>&nbsp;/&nbsp;</span>
                  <br />
                </>
              }

              <span>{elUpd}&nbsp;</span>

              {(!!elUpd || elUpd === 0) &&
                <span className="table-info-footer__cell_units">
                  {unitsArr?.[index]?.unit}
                </span>
              }

              {unitsArr?.[index]?.subUnit &&
                <span className="table-info-footer__cell_sup">{unitsArr?.[index]?.subUnit}</span>
              }
            </div>
          </TableInfoCell>
        )
      }
    });
  }, [totals, selectedTotals, rows, checkList, unitsArr]);

  return (
    <div
      className={classNames({
        "table-info-footer": true,
        "table-info-footer__selected": !!selectedTotals && Array.isArray(selectedTotals) && !!selectedTotals.length,
      })}
    >
      {cols}
    </div>
  );
};

export default TableInfoFooter;
